import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'


const StyledHeader = styled.header`
  .backBtn {
    width: 90%;
    margin: 1rem auto;
    display: flex;
    align-items: center;
    small {
      font-size: 14px;
      margin-left: 8px;
    }
  }

  /* Canonical button style — matches the login page submit button
     (src/pages/LoginPage/LoginPage.tsx '.submit-btn') for visual
     consistency across the app. Scoped to this component only (rather
     than overriding the shared global '.c-button' class in
     src/index.css) so the many other unrelated '.c-button' usages
     elsewhere in the app are left untouched. */
  .c-button {
    background: var(--Gold-Gradient-01);
    color: #fff !important;
    border-radius: 10px;
    box-shadow: 0px 4px 6.15px rgba(0, 0, 0, 0.21);
  }
`

export default function MobileHeader({ isLobby=false }) {
  const history = useHistory()

  const goBack = () => {
    history.goBack()
  }
  
  return (
    <StyledHeader>
      {/* <img src={fixedAssets.bannerM} width="100%" className="mx-auto d-block m-0" alt="event visual" /> */}
      {!isLobby &&
        <div className='btn c-button px-4 py-1 ml-4 mt-2' onClick={goBack}>
          <small>Back</small>
        </div>
      }
    </StyledHeader>
  )
}
